module.exports = __webpack_public_path__ + "media/plastic_1.38ece043.webm";